import { render, staticRenderFns } from "./CompletarFrase.vue?vue&type=template&id=67347208&"
import script from "./CompletarFrase.vue?vue&type=script&lang=js&"
export * from "./CompletarFrase.vue?vue&type=script&lang=js&"
import style0 from "./CompletarFrase.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports